{
	"title": "Säkerställa ansvarstagande genom att införa en koldioxidbank",
	"description": "Heidelberg Materials har vidtagit grundliga åtgärder för att säkerställa trovärdigheten i de koldioxidminskningar som genereras av vår CCS-cementanläggning. För att förhindra alla möjligheter till dubbelräkning har vi infört en säker virtuell koldioxidbank på en offentlig distribuerad liggare.",
	"traceabilityTitle": "Spårbarhet för koldioxidminskningar"
}
